module.exports = __webpack_public_path__ + "img/compact.06968228.png";